import { gql } from "@apollo/client";

const DELETE_USER = gql`
  mutation deleteUserMutation {
    deleteUser
  }
`;

export default DELETE_USER;
